import { snakeToCamelCaseObject } from "../../utils";
import { fromLegacyServiceAgentSession, isLegacyServiceAgentSession } from "./sessions.legacy";
export * from "./sessions.events";
export * from "./sessions.eventData";
export * from "./sessions.legacy";
/**
 * Converts a raw service session (legacy or ADK) into the AgentSession type
 * {@link AgentSession} — `events` is handled separately since mapping events requires the async
 * `data` parsing that lives in the modules layer.
 */
export function agentSessionFromService(serviceSession) {
    if (isLegacyServiceAgentSession(serviceSession)) {
        return fromLegacyServiceAgentSession(serviceSession);
    }
    const { lastUpdateTime, ...session } = snakeToCamelCaseObject(serviceSession);
    return {
        id: session.id,
        userId: session.userId,
        appName: session.appName,
        lastUpdateTime: lastUpdateTime ? lastUpdateTime * 1000 : undefined
    };
}
//# sourceMappingURL=index.js.map